

























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface CollectionDetailTabLocationItem {
  holdingBranchCode: SystemCode
  mark: string
  departmentCode: SystemCode
  ndc: string
  shelfTypeOld: SystemCode
  forwardingBranchCode: SystemCode
  book: string
  specialShelfLimitDate: string // 日付
  shelfType: SystemCode
  sub: string
  organizeFlag: boolean
  sendFlag: boolean
}

export const defaultCollectionDetailTabLocationItem = (): CollectionDetailTabLocationItem => ({
  holdingBranchCode: defaultSystemCode(),
  mark: '',
  departmentCode: defaultSystemCode(),
  ndc: '',
  shelfTypeOld: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  book: '',
  specialShelfLimitDate: '', // 日付
  shelfType: defaultSystemCode(),
  sub: '',
  organizeFlag: false,
  sendFlag: false
})

@Component({
  components: {}
})
export default class CollectionDetailTabLocation extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: CollectionDetailTabLocationItem

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  get organizeFlagText(): string {
    if (this.isOrder) {
      return (
        (this.item.organizeFlag ? '指示する' : '指示しない') +
        '／' +
        (this.item.sendFlag ? '送信済' : '未送信')
      )
    }

    return ''
  }
}
